module.exports = __webpack_public_path__ + "img/118.10.7e395340.png";